import React, { useState } from "react";
import Giveaway from "./GiveAway/GiveAway";
import Donation from "./Donation/Donation";
import UserDonation from "./UserDonation/UserDonation";
import BiddingPanel from "./BiddingPanel/BiddingPanel";
import UserBidding from "./UserBidding/UserBidding";
import GiftCard from "./GiftCard/GiftCards/GiftCard";
import GiftCardRequests from "./GiftCard/GiftCardRequests/GiftCardRequests";
import GiftCardRequestComplete from "./GiftCard/GiftCardComplete/GiftCardComplete";
import GiftCardRequestCancelled from "./GiftCard/GiftCardCancelled/GiftCardCancelled";
import AgencyTabURL from "./AgencyTabURL";
import RedeemMethodsUrlTab from "./RedeemMethodsUrlTab";



const TransactionUrlTab = () => {
  const [activeComponent, setActiveComponent] = useState("Donation Transactions");
  // Array with tab names and corresponding components
  const tabs = [
   
    { name: "Donation Transactions", component: <UserDonation /> },
    { name: "Luckydraw Transactions", component: <UserBidding /> },
    { name: "Gift Card Requests", component: <GiftCardRequests /> },
    { name: "Gift Card Request Complete", component: <GiftCardRequestComplete /> },
    { name: "Gift Card Request Cancelled", component: <GiftCardRequestCancelled /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name) => {
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col  w-[100%] items-center p-6 pt-1">
        <div className="flex space-x-2 mb-6 flex-wrap gap-2">
          {tabs.map(({ name }) => (
            <button
              key={name}
              className={`px-3 py-2 rounded-lg text-sm border-b-2 ${activeComponent === name
                  ? "activeBtn text-white"
                  : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
                }`}
              onClick={() => { changeActiveComponent(name) }}
            >
              {name}
            </button>
          ))}
        </div>
         <div className="w-[100%]">
         {renderComponent()}
         </div>
    </div>
  );
};

export default TransactionUrlTab;
